import { Box, withStyles } from 'vopay';
import { Title, SideDrawer } from 'UI';
import { useTranslation } from 'react-i18next';
import UserManagement from '@/components/Users/UserManagement';
import styles from './UserManagementDrawer.module.scss';

const cn = withStyles(styles);

type UserManagementDrawerProps = {
  accountToken: string;
  accountName: string;
  open: boolean;
  onClose: () => void;
};

export default function UserManagementDrawer({ accountToken, accountName, open, onClose }: UserManagementDrawerProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.UserManagement' });

  return (
    <SideDrawer
      isOpen={open}
      onClose={onClose}
      title={
        <Box flx="col" gapSize="4px">
          <Title level="3">{t('title', { defaultValue: 'User Management' })}</Title>
          <div className={cn('name')}>{accountName}</div>
        </Box>
      }
      style={{
        width: 'calc(100% - var(--navLeftWidthSmall, 80px))',
      }}
      onEscapeKeyDown={(e) => e.preventDefault()}
      shrinkable={false}
    >
      <UserManagement bearer={accountToken} />
    </SideDrawer>
  );
}
